<template>
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
        <FormItem label="账号" prop="account">
            <Input type="text" :placeholder="accrule" v-model="formCustom.account" @on-change="showtips=false"></Input>
        </FormItem>
        <FormItem label="密码" prop="passwd">
            <Input type="password" :placeholder="pwdrule" v-model="formCustom.passwd" @on-change="showtips=false"></Input>
        </FormItem>
        <FormItem label="密码确认" prop="passwdCheck">
            <Input type="password" v-model="formCustom.passwdCheck" @on-change="showtips=false"></Input>
        </FormItem>
        <FormItem label="单位名称" prop="unitname">
            <Input type="text" v-model="formCustom.unitname" placeholder="请填写单位名称"></Input>
        </FormItem>
        <!-- <FormItem label="单位电话" prop="unittel">
            <Input type="text" v-model="formCustom.unittel" placeholder="请填写单位电话"></Input>
        </FormItem> -->
        <FormItem label="所属行业" prop="industrycode">
            <Select v-model="formCustom.industrycode" placeholder="请选择所属行业" clearable transfer style="text-align: left;">
                <Option v-for="item in industryData" :value="item.industryid" :key="item.industryid">{{ item.title }}</Option>
            </Select>
        </FormItem>
        <FormItem label="联系电话" prop="unittel">
            <Input disabled type="text" v-model="formCustom.unittel" placeholder="请填写联系电话"></Input>
        </FormItem>
        <!-- <FormItem label="所在地域" prop="locationcode">
            <Cascader v-model="formCustom.locationcode" :data="citys" change-on-select :placeholder="holdertext" @on-change="onChange"></Cascader>
        </FormItem> -->
        <!-- <p>注册成功后,请及时关注微信公众号“众智云擎”,点击“云擎中心”按钮进入“文件提醒”,即时获取云端文件效力变动信息及税收优惠推送。</p> -->
        <FormItem>
            <Alert>
                特别提示
                <template slot="desc">
                    <p>注册成功后,请及时关注微信公众号“众智云擎税法检索”,点击“云擎中心”按钮进入“文件提醒”绑定账号,即时精准获取税法文件智能推送。 </p>
                </template>
            </Alert>
        </FormItem>
        <!--   <Button type="primary" @click="handleSubmit">Primary</Button> -->
    </Form>
</template>
<script>
import store from '../../store'
import regJson from '../../api/security/reg.js'
let regJ = new regJson()
//已通过短信码验证后,填写注册信息
export default {
    name: 'UserReg2',
    data() {
        const validateAccount = (rule, value, callback) => {
            // console.log("validateAccount...")
            // console.log(rule, value, this.formCustom.account)
            if (value === '') {
                callback(new Error('请输入账号'));
            } else {
                if (value.length > 12 || value.length<3) {
                    callback(new Error(this.accrule));
                }
                if (this.checkAcc(value)) {
                    //账号远端有效性校验
                    regJ.reqCheckUserId('', value).then(res => {
                        console.log(res)
                        if (res.rtncode === 1) {
                            if (res.rltcode === 1) {
                                if (res.enabled) {
                                    callback()
                                } else {
                                    callback(new Error(res.recommend));
                                }
                            } else {
                                //特殊处理下提示信息,检测账号是否重复
                                if (res.rltcode === -1) {
                                    // callback(new Error(this.existDesc));
                                    callback(new Error(res.rltdesc));
                                } else {
                                    callback(new Error(res.rltdesc));
                                }
                            }
                        } else {
                            callback(new Error(res.rtndesc));
                        }
                    })

                } else {
                    callback(new Error(this.accrule));
                }
            }
        };

        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.formCustom.passwdCheck !== '') {
                    // 对第二个密码框单独验证
                    this.$refs.formCustom.validateField('passwdCheck');
                }
                callback();
            }
        };
        const validatePassCheck = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error(this.pwdrule));
            }

            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (value !== this.formCustom.passwd) {
                callback(new Error('两次密码输入不一致'));
            } else {
                callback();
            }
        };

        //校验单位名称
        const validateUnitName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入单位名称'));
            } else {
                callback();
            }
        }
        //校验单位电话
        const validateUnitTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入单位电话'));
            } else {
                callback();
            }
        }
        //校验所属行业信息
        const validateIndustryCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择所属行业'));
            } else {
                callback();
            }
        }
        //校验所属地域信息
        const validateLocationCode = (rule, value, callback) => {
            if (!value || value.length === 0) {
                callback(new Error('请选择所属地域'));
            } else {
                callback();
            }
        }

        // const validateAgreement = (rule, value, callback) => {
        //   console.log('validateAgreement:'+value)
        //   if (value===false) {
        //     callback(new Error('请同意协议并提交注册'));
        //   }else{
        //     callback();
        //   }
        // };

        return {
            // value: [{ label: "　", value: "" },
            //     { label: "　", value: "" }
            // ],
            holdertext: '请选择所在地域',
            citys: this.getProvinceCity(),
            industryData: this.getIndustryData(),
            formCustom: {
                account: '',
                passwd: '',
                passwdCheck: '',
                unitname: '',
                unittel: '',
                industrycode: '',
                locationcode: [],
                // agreement: true,
            },
            ruleCustom: {
                account: [{ required: true, validator: validateAccount, trigger: 'blur' }],
                passwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
                passwdCheck: [{ required: true, validator: validatePassCheck, trigger: 'blur' }],
                unitname: [{ required: true, validator: validateUnitName, trigger: 'blur' }],
                unittel: [{ required: true, validator: validateUnitTel, trigger: 'blur' }],
                industrycode: [{ required: true, validator: validateIndustryCode, trigger: 'blur' }],
                //locationcode: [{ required: true, validator: validateLocationCode, trigger: 'blur' }],
                // agreement: [
                //   { required: true, type:'boolean',validator: validateAgreement, trigger: 'change' }
                // ],
            },
            showtips: false,
            accrule: '账号必须是由3-12位的字母或数字组成',
            // accrule: '账号只能使用数字或字母,长度不超过12位',
            pwdrule: '密码长度至少6位',
            existDesc: '该账号名已被注册，请重新设置',

        }
    },
    methods: {
        handleSubmit() {
            //console.log(this.formCustom)
            this.$refs['formCustom'].validate((valid) => {
                if (valid) {
                    console.log(this.formCustom)
                    this.$emit('regInfoReady', this.formCustom);
                }
            })
        },
        getProvinceCity() {
            let res = store.state.user.initData.provinceCity
            return res
        },
        getIndustryData() {
            let res = store.state.user.initData.offersIndustry
            return res
        },
        // industryChange(value){
        //    console.log(value)
        //    console.log(this.formCustom.industrycode)
        // },
        onChange(val, data) {
            console.log(data)
            this.formCustom.locationcode = data
        },
        // setAgreement() {
        //     this.formCustom.agreement = true
        // },
        // userAgreement() {
        //     this.$emit('show-agreement')
        // },
        // handleSubmit(name) {
        //     this.$refs[name].validate((valid) => {
        //         if (valid) {
        //             this.showtips = false;
        //             console.log(this.formCustom)
        //             this.$emit('regSetPwdOk', this.formCustom);
        //             //this.$Message.success('注册成功!');
        //             //ajax 成功则关闭,并跳转至登录

        //             //console.log(this.formCustom);
        //         } else {
        //             //this.$Message.error('Fail!');
        //             this.showtips = true;
        //         }
        //     })
        // },
        handleReset(name) {
            console.log('handleReset---->')
            this.$refs[name].resetFields();
            this.formCustom.account = ''
            this.formCustom.passwd = ''
            this.formCustom.passwdCheck = ''
            this.formCustom.unitname = ''
            this.formCustom.unittel = ''
            this.formCustom.industrycode = ''
            //不显示了
            //this.formCustom.locationcode = []
            // console.log('reg-set-password clear')
            this.showtips = false;
        },
        checkAcc(txt) {
            if (!(/^[0-9a-zA-Z]{1,}$/.test(txt))) {
                return false;
            } else {
                return true;
            }
        },

    },
    created() {
        console.log('clear reg-set-password')
        // this.formCustom.account = ''
        // this.formCustom.passwd = ''
        // this.formCustom.passwdCheck = ''
    }

}
</script>
<style>
</style>